import { render, staticRenderFns } from "./chuangyi.vue?vue&type=template&id=37532524&scoped=true&"
import script from "./chuangyi.vue?vue&type=script&lang=js&"
export * from "./chuangyi.vue?vue&type=script&lang=js&"
import style0 from "./chuangyi.vue?vue&type=style&index=0&id=37532524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37532524",
  null
  
)

export default component.exports